import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp, getOrderKey, pythonApiIp , logDashboardAction} from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'



class AddSalesPerson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            salesPerson: '',
            orderTypeChoices: [],
            salesPeopleChoices: []
        }
    }

    componentDidMount() {
        //SHIRT COLORS
        //this.getSalesPeopleDropdown();
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        //console.log('lst12 You\'ve sss:', value);
        console.log("getSales3 category alone:" + value.category);
        console.log("getSales30 label:" + value.label);
        console.log('getSales31 You\'ve selected:', value.value + " " + value.category + " " + value.phone);
        // console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        // console.log("lst16 - array index:" + this.props.arrayIndex);

        this.setState({
            salesPersonId: value.value,
            salesPerson: value.label,
            salesPerson_phone: value.phone,
        })

        // let newState = {};
        // newState[value.category] = value.value;
        // newState['salesPerson'] = value.label;
        // console.log("newState 1:" + JSON.stringify(newState, null, 3));

        // //this.setState(newState);
        // this.setState(newState);
    }


    // getSalesPeopleDropdown() {
    //     console.log("salx1 +++++++++: getArtistInfo");
    //     axios.post(serverIp + 'salesApp/getSalesPeople', {
    //         apiKey: "123123"
    //     })
    //         .then((response) => {
    //             console.log("salx12:" + JSON.stringify(response.data, null, 3));
    //             this.setState({
    //                 loading: false,
    //                 salesPeopleChoices: response.data.dropdownItems
    //             })
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             this.setState({
    //                 loading: false
    //             })
    //         });
    // }

    changeSalesPerson = () => {
        console.log("mk1 ++++++++++++++ selectDesigner");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            salesPerson: this.state.salesPerson,
            lastUpdated: now,
            //lastUpdatedBy:this.props.user.email,
            salesPersonUpdateBy: this.props.user.email,
            salesPerson_phone: this.state.salesPerson_phone
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        axios.post(pythonApiIp + 'changeSalesPerson', {
            apiKey: "Psdfsdfasdf",
            fbOrderKey: getOrderKey(this.props.order),
            salesPersonId: this.state.salesPersonId,
            enteredBy: this.props.user.email
        })
            .then(function (response) {
                console.log(response.data);
                if (response.data.result) {
                    alert(response.data.message)
                } else if (!response.data.result) {
                    alert(response.data.message)
                }
            })
            .catch(function (error) {
                console.log(error);
                alert("Unable to update salesperson")
            });

    }

    sendDesignToSales = () => {
        console.log("mk1 ++++++++++++++ sendDesignToSales");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            lastUpdated: now,
            sendDesignToSales: true,
            sendDesignToSales_added_by: this.props.user.email
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        //(logAction, adminEmail, order_num, componentName)
        let updateString = "sendDesignToSales added order "+this.props.order.order_num+" by "+this.props.user.email;
        logDashboardAction(updateString, this.props.user.email , this.props.order.order_num, "sendDesignToSales");

    }

    remove_sendDesignToSales = () => {
        console.log("mk1 ++++++++++++++ sendDesignToSales");


        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            lastUpdated: now,
            sendDesignToSales: false,
            sendDesignToSales_removed_by: this.props.user.email
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);


        let updateString = "sendDesignToSales remved order "+this.props.order.order_num+" by "+this.props.user.email;
        logDashboardAction( updateString, this.props.user.email , this.props.order.order_num, "sendDesignToSales");

    }

    render() {

        const showDesigner = this.props.order.orderType && this.props.order.salesPerson
            ? <h4>SALES PERSON:{this.props.order.salesPerson} {this.props.order.salesPerson_phone}</h4>
            : ''

        const lostButton = this.state.salesPerson !== ''
            ? <Button color='pink' fluid onClick={this.changeSalesPerson}> SET Sales Person</Button>
            : ''

        const sendDesignToDesigner = this.props.order.orderType && this.props.order.salesPerson && this.props.order.salesPerson_phone && !this.props.order.sendDesignToSales
            ? <Button color='purple' fluid onClick={this.sendDesignToSales}> SEND DESIGN TO SALES</Button>
            : ''

        const remove_sendDesignToDesigner = this.props.order.orderType && this.props.order.salesPerson && this.props.order.salesPerson_phone && this.props.order.sendDesignToSales
            ? <Button color='purple' fluid onClick={this.remove_sendDesignToSales}> Rmve SEND DESIGN TO SALES</Button>
            : ''

        const sendDesignToDesignerUi = this.props.order.orderType && this.props.order.salesPerson && this.props.order.salesPerson && this.props.order.sendDesignToSales
            ? <h4>SEND DESIGN TO SALES: YES, TO: {this.props.order.salesPerson_phone}</h4>
            : ''

        const wholeUi = this.props.user.email
            ? <div>
                <Divider horizontal>{'SET SALES PERSON!'}</Divider>
                {showDesigner}
                <Select
                    name="form-field-name"
                    value={this.state.salesPersonId}
                    options={this.props.salesPeopleChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                {lostButton}
                <br />
                {sendDesignToDesigner}
                {remove_sendDesignToDesigner}
                {sendDesignToDesignerUi}
            </div>
            : ''


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default AddSalesPerson;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Sales/AddSalesPerson.js